import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=d15e290a&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d15e290a')) {
      api.createRecord('d15e290a', component.options)
    } else {
      api.reload('d15e290a', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=d15e290a&", function () {
      api.rerender('d15e290a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Q06TGqo7HFwH/JS/comp/childrenage.vue"
export default component.exports